import { ILocation } from '../../api/locations';
import { getRegionId, MOId } from '../../utils/geo';
import { IMakeRequest } from '../../utils/request';

export interface IDirection {
  highways: IHighway[];
  name: string;
}

export interface IHighway {
  fullName: string;
  id: number;
  name: string;
}

export interface IRequestDirectionsData {
  data: IDirection[];
  regionId: number;
}

export const directions = {
  requestData(makeRequest: IMakeRequest, regionId: number): Promise<IRequestDirectionsData> {
    return makeRequest({
      uri: {
        path: '/api/geo/get-roads',
        query: `regionId=${regionId}`,
      },
      method: 'GET',
    }).then(data => {
      return {
        data,
        regionId,
      } as IRequestDirectionsData;
    });
  },

  getRegionId(location: ILocation | 'moscow_mo' | 'spb_lo'): number {
    let regionId = getRegionId(location);

    if (regionId === -1) {
      regionId = MOId;
    }

    return regionId;
  },
};
